import script from "./SubtitlePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SubtitlePanel.vue?vue&type=script&setup=true&lang=js"

import "./SubtitlePanel.vue?vue&type=style&index=0&id=6a49e4b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a49e4b9"]])

export default __exports__